const KEY = 'postLoginRedirect';

/**
 * Login is multi-step (phone/email verification), so router state can't carry the
 * intended destination through it — sessionStorage can. Relative paths only, to
 * keep email deep links from becoming an open-redirect vector.
 */
export function storePostLoginRedirect(path: string): void {
  try {
    if (path.startsWith('/') && !path.startsWith('//')) {
      sessionStorage.setItem(KEY, path);
    }
  } catch {
    // storage unavailable — login just lands on the default page
  }
}

export function consumePostLoginRedirect(): string | null {
  try {
    const stored = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return stored && stored.startsWith('/') && !stored.startsWith('//') ? stored : null;
  } catch {
    return null;
  }
}
